import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}
export function Card({
  children,
  className = '',
  ...props
}: CardProps) {
  return <div className={`bg-white rounded-xl border border-gray-200 shadow-sm ${className}`} {...props} data-id="element-302">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className = '',
  ...props
}: CardProps) {
  return <div className={`px-6 py-4 border-b border-gray-100 flex flex-col space-y-1.5 ${className}`} {...props} data-id="element-303">
      {children}
    </div>;
}
export function CardTitle({
  children,
  className = '',
  ...props
}: CardProps) {
  return <h3 className={`text-lg font-semibold text-gray-900 leading-none tracking-tight ${className}`} {...props} data-id="element-304">
      {children}
    </h3>;
}
export function CardContent({
  children,
  className = '',
  ...props
}: CardProps) {
  return <div className={`p-6 ${className}`} {...props} data-id="element-305">
      {children}
    </div>;
}